import { Component, Input } from '@angular/core';
import { Summary } from '../models/summary';

@Component({
    selector: 'app-summary',
    templateUrl: './summary.component.html',
    styleUrls: ['./summary.component.scss'],
    standalone: false
})
export class SummaryComponent {
  @Input() summary: Summary;
}
